import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import {
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
  FaEnvelope,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <h2 className="footer-logo">LORETECH.LS</h2>
        <hr className="decor-line" />

        <div className="footer-columns">
          <div className="footer-column">
            <h3>Legal</h3>
            <Link to="/politica-privacidade">Política de privacidade</Link>
            <Link to="/configuracoes-cookies">Configurações de cookies</Link>
          </div>

          <div className="footer-column">
            <h3>Contato</h3>
            <a
              href="https://wa.me/5511988833017"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp
            </a>
            <a href="mailto:loretechls@gmail.com">E-mail</a>
          </div>

          <div className="footer-column">
            <h3>Redes Sociais</h3>
            <a
              href="https://www.instagram.com/loretech.ls"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
            <a
              href="https://www.linkedin.com/in/lorena-santos--"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </div>

          <div className="footer-column">
            <h3>Atendimento</h3>
            <p>Segunda às sexta das 10:30 às 19:00h.</p>
          </div>
        </div>

        <div className="footer-icons">
          <a
            href="https://wa.me/5511988833017"
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://instagram.com/loretechls"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="mailto:contato@loretechls.com.br"
            target="_blank"
            rel="noreferrer"
          >
            <FaEnvelope />
          </a>
          <a
            href="https://linkedin.com/in/lorena-santos--"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © Copyright 2025 Lorena Santos —{" "}
          <a
            href="https://instagram.com/loretech.ls"
            target="_blank"
            rel="noreferrer"
          >
            Loretech.ls
          </a>
          . Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
